import type IMembershipPeriodMessagingDismissalElements from './IMembershipPeriodMessagingDismissalElements';

function getKey(id: string) {
  return `mpm-dismissed-${id}`;
}

function hide($container: HTMLElement) {
  if ($container.classList.contains('tn-utility-nav-membership-period-messaging--dismissed')) return;

  const { height } = $container.getBoundingClientRect();

  $container.style.height = `${height}px`;

  const removeAfter = () => {
    $container.style.display = 'none';
    $container.removeEventListener('transitionend', removeAfter);
  };

  window.setTimeout(() => {
    $container.style.height = '0';
    $container.addEventListener('transitionend', removeAfter);
    $container.classList.add('tn-utility-nav-membership-period-messaging--dismissed');
  }, 16);
}

function clearAll() {
  try {
    const keysToRemove: string[] = [];
    for (let i = 0; i < sessionStorage.length; i += 1) {
      const k = sessionStorage.key(i);
      if (k && k.indexOf('mpm-dismissed-') === 0) {
        keysToRemove.push(k);
      }
    }
    keysToRemove.forEach((k: string) => sessionStorage.removeItem(k));
  } catch (e) { }
}

function init(elements: IMembershipPeriodMessagingDismissalElements) {
  const allElements = elements.getAll();
  if (!allElements.length) return;

  allElements.forEach(({ $container, $closeButton, membershipId }) => {
    const key = getKey(membershipId);

    if (sessionStorage.getItem(key) === '1') {
      $container.style.display = 'none';
      return;
    }

    $container.classList.remove('tn-utility-nav-membership-period-messaging--initially-hidden');

    if (!$closeButton) return; // Not dismissable

    $closeButton.addEventListener('click', (ev) => {
      ev.preventDefault();
      sessionStorage.setItem(key, '1');
      hide($container);
    });
  });
}

export default { init, clearAll };
